export class Solicitation {
    constructor() {}

    solicitationId: number;
    statusId: number;
    statusDescription: string;
    quantityCards: number;
    solicitationDate: Date;
    deliveryDate?: Date;
    trackingCode: string;
}

export class CardSolicitationItems {
    constructor() { }

    quantityCards: number;
    personGuid: string;
    collaboratorId: number;
    useCollaboratorAddress: boolean;
}

export class CardSolicitationItem {
    constructor() { }

    solicitationItemId: number;
    statusId: number = 5;
    reason: string;
}
